exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, "i[data-v-34282870]{font-style:normal!important}.icon-lg[data-v-34282870]{font-size:1.09375rem}.icon-md[data-v-34282870]{font-size:inherit}.icon-sm[data-v-34282870]{font-size:.76563rem}", ""]);

// exports
